import { c as _c } from "react/compiler-runtime";
import { AppLayout } from '@src/components/sco/AppLayout';
import { AppLayoutPanelProps } from '@src/components/sco/AppLayout/Panel';
import { EducationContextProvider } from '@src/components/sco/Education/EducationContext';
import { EducationAside } from '@src/components/sco/Education/Layout/EducationAside';
import { EducationNav } from '@src/components/sco/Education/Layout/EducationNav';
import { ScoSiteNavBar } from '@src/components/sco/nav/ScoSiteNavBar';
import { useAppContextStore } from '@src/contexts/AppContextStore';
import React, { ReactNode } from 'react';
type EducationLayoutProps = {
  asidePanel?: ReactNode;
  mainPanel?: ReactNode;
  navPanel?: ReactNode;
};
export const EducationLayout: React.FC<EducationLayoutProps> = props => {
  const $ = _c(27);
  const {
    contextStore
  } = useAppContextStore();
  const [asidePanelIsOpen, setAsidePanelIsOpen] = React.useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      base: true,
      md: false
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.navPanel) {
    t1 = props.navPanel ? props.navPanel : <EducationNav />;
    $[1] = props.navPanel;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      bgColor: "transparent",
      border: 0,
      boxShadow: 0
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = {
      id: "edu-nav",
      useDrawerBreakpoints: t0,
      isResizable: true,
      resizeHandlePosition: "right",
      defaultWidth: 280,
      minWidth: 200,
      maxWidth: 400,
      children: t1,
      isPanelOpen: true,
      isDrawerOpen: false,
      containerProps: t2
    };
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props.mainPanel) {
    t4 = {
      id: "edu-main",
      children: props.mainPanel,
      isPanelOpen: true,
      isDrawerOpen: true,
      resetScrollOnPathChange: true
    };
    $[6] = props.mainPanel;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      base: true,
      lg: false
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== props.asidePanel) {
    t6 = props.asidePanel || <EducationAside />;
    $[9] = props.asidePanel;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setAsidePanelIsOpen(false);
    };
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== asidePanelIsOpen || $[13] !== t6) {
    t8 = {
      id: "edu-aside",
      useDrawerBreakpoints: t5,
      isResizable: true,
      resizeHandlePosition: "left",
      drawerPlacement: "right",
      defaultWidth: 460,
      minWidth: 300,
      maxWidth: 600,
      children: t6,
      isPanelOpen: asidePanelIsOpen,
      onPanelClose: t7,
      isDrawerOpen: false
    };
    $[12] = asidePanelIsOpen;
    $[13] = t6;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t3 || $[16] !== t4 || $[17] !== t8) {
    t9 = [t3, t4, t8];
    $[15] = t3;
    $[16] = t4;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const panels = t9;
  let t10;
  if ($[19] !== contextStore) {
    t10 = contextStore.getNamespace("EducationContext");
    $[19] = contextStore;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <ScoSiteNavBar />;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== panels) {
    t12 = <AppLayout header={t11} id="education-layout" panels={panels} />;
    $[22] = panels;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t10 || $[25] !== t12) {
    t13 = <EducationContextProvider {...t10}>{t12}</EducationContextProvider>;
    $[24] = t10;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  return t13;
};